import {Text} from '@di-nxt/components';
import React, {useMemo} from 'react';
import {getFormattedData} from './getFormattedData';

type Props = {
  data?: number | string | boolean;
  onPress?: (data: number | string | boolean) => void;
};

export const DataRowData: React.FC<Props> = ({data, onPress}) => {
  const handleOnPress = useMemo(
    () => (onPress && data ? () => onPress(data) : undefined),
    [data, onPress],
  );

  return (
    <Text variant="inline_14_default" onPress={handleOnPress}>
      {getFormattedData(data)}
    </Text>
  );
};
